import { ValueOf } from '../types';

const analysisTypes = {
  RISK_AREAS: 'risk-areas',
  INVESTIGATION: 'investigation',
  CUSTOM: 'custom',
} as const;

export const analysisTypeChoices = [
  {
    id: analysisTypes.RISK_AREAS,
    name: 'Risk areas',
  },
  {
    id: analysisTypes.INVESTIGATION,
    name: 'Investigation',
  },
  {
    id: analysisTypes.CUSTOM,
    name: 'Custom',
  },
];

export const analysisDescription: Record<AnalysisType, string> = {
  [analysisTypes.RISK_AREAS]: 'Analyze the key risk areas for this case.',
  [analysisTypes.INVESTIGATION]: 'Provide a detailed investigation summary with key findings and recommended actions for this case.',
  [analysisTypes.CUSTOM]: 'E.g. summarize key risks, patterns, and recommended actions.',
};

export type AnalysisType = ValueOf<typeof analysisTypes>;

export default analysisTypes;
